import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['modal'];
    static classes = ["open"];

    widthdraw_modal(event){
        event.preventDefault();
        this.modalTarget.classList.toggle(this.openClass);
    }
}
